import React, { useEffect, useState, useRef } from "react";
import "./AutoComplate.css";
import {
  Table,
  Menu,
  Dropdown,
  Drawer,
  Modal,
  Input,
  Tabs,
  Empty,
  notification,
  Select,
  Form,
  message,
  Button,
  Row,
  Col,
  Tooltip,
  Spin,
  Popconfirm,
} from "antd";
import {
  PlusOutlined,
  DownloadOutlined,
  BarsOutlined,
  WarningOutlined,
  MailFilled,
  CheckCircleOutlined,
  MailOutlined,
  FileExcelOutlined,
  MinusOutlined,
  FilePdfOutlined,
  EditOutlined,
  TagsOutlined,
  RollbackOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import ReactTags from "react-autocomplete-tag";
import config from "../../util/ApiforContext";
import moment from "moment";
import { useMediaQuery } from "react-responsive";
import FirmAddForm from "../Forms/FirmAddForm";
import Screen from "../../util/Extensions/Screens";
import Iframe from "react-iframe";
import { ColumnHelper, RowHelper } from "util/TableHelper";
import RequestHandler from "../../util/RequestHandler";
import { odata, queryHelper } from "../Filters/Helper";

import ConsolidateAccountTransactionTableFilter from "../Filters/ConsolidatedAccountTransactionTableFilter";
import { useHistory } from "react-router-dom";
import { Option } from "antd/lib/mentions";
import { useTranslation } from "react-i18next";

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 13,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 15,
    span: 5,
  },
};
const tailLayouttwo = {
  wrapperCol: {
    offset: 15,
    span: 40,
  },
};

const ConsolidatedAccountPage = () => {
  const isInitialMount = useRef(true);
  const defaultTableDataQueryOptions =
    queryHelper.getDefaultTableDataQueryOptions();
  defaultTableDataQueryOptions.activeTab = "0";
  defaultTableDataQueryOptions.groupId = "";

  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    defaultTableDataQueryOptions
  );
  const [currencyTabList, setCurrencyTabList] = useState([]);

  const [loading, setLoading] = useState(false);
  const [accountIdForModalReceipt, setAccountIdForModalReceipt] = useState("");
  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });
  const [wordList, setWordList] = useState([]);
  const [loadingForWords, setLoadingForWords] = useState(false);
  const [firmId, setFirmId] = useState("");
  const [Vkn, setVkn] = useState("");
  const [Tckn, setTckn] = useState("");
  const [senderName, setSenderName] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");

  const [isTransactionTimeFilter, setTransactionTimeFilter] = useState([]);
  const [isHasDateFilter, setIsHasDateFilter] = useState(null);
  const [isLast7DaysFilterEnabled, setIsLast7DaysFilterEnabled] = useState(false);
  const [isLast1DayFilterEnabled, setIsLast1DayFilterEnabled] = useState(false);
  const [oldVkn, setOldVkn] = useState("");
  const [newVkn, setNewVkn] = useState("");
  const [newTckn, setNewTckn] = useState("");
  const [oldTckn, setOldTckn] = useState("");

  const [spinLoading, setSpinLoading] = useState(false);
  const [isModalVisibleReceipt, setIsModalVisible] = useState(false);
  const [isModalTagVisible, setIsModalTagVisible] = useState(false);
  const [vknTcknModal, setVknTcknModal] = useState(false);
  const [AccountId, setAccountId] = useState("");
  const [Id, setId] = useState("");
  const [firmIdForVknTckn, setFirmIdForVknTckn] = useState("");
  const [descriptionForMatch, setDescriptionForMatch] = useState("");
  const [Email, setEmail] = useState(localStorage.getItem("email"));
  const [EmailVisible, setEmailVisible] = useState(true);

  const [addFirmDrawerVisible, setAddFirmDrawerVisible] = useState(false);
  const [visibledWords, setVisibleWords] = useState(false);

  const [visibleUpdate, setVisibleUpdate] = useState(false);

  const [visibled, setVisibled] = useState(false);
  const [isFirmHidden, setIsFirmHidden] = useState(true);
  const [tableRoles, setTableRoles] = useState({});
  const [accountTransactionId, setAccountTransactionId] = useState();
  const [isHaveAccountRole, setIsHaveAccountRole] = useState({
    data: false,
    loading: true,
  });
  const [tags, setTags] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [prevTagList, setprevTagList] = useState([]);

  const [groups, setGroups] = useState([]);
  const [groupId, setGroupId] = useState("");

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });
  const history = useHistory();

  const [visibleNoteUpdate, setVisibleNoteUpdate] = useState(false);
  const [drawerNoteUpdate, setDrawerNoteUpdate] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [deleteModalVisibleMap, setDeleteModalVisibleMap] = useState({});

  const [showExchangePriceAndRate, setShowExchangePriceAndRate] =
    useState(false);

  const [firstGroup, setFirstGroup] = useState("");
  const { t } = useTranslation();

   useEffect(
      () => {
        if (!isInitialMount.current) {
  
          getTableData();
        }
      },
      [tableDataQueryOptions]);

      
    useEffect(() => {
      dateFilter();
    }, [isHasDateFilter, isLast1DayFilterEnabled, isLast7DaysFilterEnabled])

   
  const dateFilter = () => {
      let startDate;

      if(isLast1DayFilterEnabled) {
        startDate =  moment(new Date()).add(-1, "days");
      }
      else if(isLast7DaysFilterEnabled) {
        startDate =  moment(new Date()).add(-7, "days");
      }else if (isHasDateFilter)  {
        startDate = moment(new Date()).add(-1, "months")  
      }


      if(startDate) {
          setTableDataQueryOptions((prevState) => {
          return {
            ...prevState,
            skip: 0,
            current: 1,
            take: tableDataQueryOptions.take,
            values: {
              transactionDateMin: startDate,
              transactionDateMax: new Date()
            },
            filter: `${odata.dateRange("transactionDateValue", startDate,new Date())}`
          }});

                
        isInitialMount.current = false;
      }
  }

  const wordArray = [];

  const updateMatchFirm = (type) => {
    notification[type]({
      message: t("success"),
      description: t("accountUpdateSuccess"),
      duration: 5,
    });
  };
  const openNotificationWithIconExcel = (type) => {
    notification[type]({
      message: t("success"),
      description: t("excelDownloadSuccess"),
      duration: 2,
    });
  };

  useEffect(() => {
    RequestHandler.get(`/Group/GetConsolidateDropdown`).then((response) => {
      onGroupChange(response[0]?.id);
      setFirstGroup(response[0]?.name);
      setGroupId(response[0]?.id);

      setGroups(response);
    });

    RequestHandler.get(
      `/TenantCurrency?$apply=groupby((Currency,CurrencyId))&$orderby=currencyId`
    ).then((response) => {
      setCurrencyTabList(response);
    });

    RequestHandler.get("/TenantUserRole/IsHaveAccountRole").then((response) => {
      setIsHaveAccountRole({
        data: response.success,
        loading: false,
      });
    });
    getTenantParameter();
  }, []);

  useEffect(() => {
    if (isHaveAccountRole.loading) {
      return;
    }

    setIsFirmHidden(true);

    RequestHandler.get(`/TenantTransactionTag/GetTransactionTagList`).then(
      (response) => {
        let tagList = [];
        response.map((item) => {
          tagList.push(item.tag);
        });
        setprevTagList(tagList);
      }
    );

    RequestHandler.get(`/AccountTransaction/GetTransactionTableRole`).then(
      (response) => {
        if (response.success) {
          setTableRoles(response.data ?? {});
        }
      }
    );
  }, [isHaveAccountRole]);

  const getFilterQuery = () => {
    const { filter, activeTab } = tableDataQueryOptions;
    let _filter = filter;

    const conditions = ["isErpActivity eq false"];
    let query = "";

    if (activeTab && activeTab !== "0") {
      conditions.push(`currencyId eq ${activeTab}`);
    }

    if (_filter) {
      conditions.push(_filter);
    }

    if (conditions.length !== 0) {
      query = "$filter=" + conditions.join(" and ");
    }
    return query;
  };

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });
    const { skip, take, order, groupId } = tableDataQueryOptions;

    RequestHandler.get(
      `/ConsolidateAccountTransaction?groupId=${groupId}&$count=true&${getFilterQuery()}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      if (Array.isArray(response.value)) {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      }
    });
  };

  const paging = (p, _, sorter) => {
    let orderValue = "";
    if (sorter.columnKey && sorter.order) {
      if (orderValue === undefined) {
        orderValue = sorter?.column?.dataIndex || undefined;
      } else {
        orderValue = sorter.columnKey;
      }

      if (orderValue && sorter.order) {
        if (orderValue === "amountString") {
          orderValue = "amount"; // backend sıralama için doğru alan
        }
      }
      orderValue =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(orderValue)
          : odata.orderByDesc(orderValue));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
        order: orderValue,
      };
    });
  };

  const onGroupChange = (value) => {
    setGroupId(value);
    setFirstGroup(value);
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        groupId: value,
        values: { groupId: value },
      };
    });
  };

  const onClearTableFilter = () => {
   if(!isHasDateFilter && !isLast1DayFilterEnabled && !isLast7DaysFilterEnabled) {
        setTableDataQueryOptions({
        skip: 0,
        current: 1,
        take: tableDataQueryOptions.take,
        filter: "",
        values: {}
      });
    }
    else {
      dateFilter();
    }
  };

  const onFinishTableFilter = (query, values) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  const onTabChange = (tabKey) => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      activeTab: tabKey,
    });
  };

  const addTag = (val) => {
    if (val.length > 1 && val.length < 21) {
      setTags([...tags, val]);
      setSuggestions([]);
    } else {
      countTagError("error");
    }
  };

  const removeTag = (idx) => {
    var t = [...tags];

    t.splice(idx, 1);

    setTags(t);
  };

  const handleTagChange = (val) => {
    if (val.length > 0) {
      var new_sug = [];
      prevTagList.forEach((t) => {
        if (t.includes(val)) {
          new_sug.push(t);
        }
      });
      setSuggestions(new_sug);
    } else {
      setSuggestions([]);
    }
  };

  const showDrawer = () => {
    setAddFirmDrawerVisible(true);
  };

  const onClose = () => {
    setAddFirmDrawerVisible(false);
    setVisibleUpdate(false);
  };

  const showModal = () => {
    setFirmSelect({ data: [], loading: false });
    setVisibled(true);
  };

  const showModalWords = () => {
    setVisibleWords(true);
  };

  const handleCancelWords = () => {
    setVisibleWords(false);
    handleCancel();
    window.location.reload();
  };

  const showModalUpdate = () => {
    setFirmSelect({ data: [], loading: true });
    let query =
      "/Firm?$select=id,firmBranchNumber,name&$filter=isActive eq true";
    if (firmId != "") {
      query = `/Firm?$select=id,firmBranchNumber,name&$filter=id eq ${firmId} and isActive eq true`;
    }

    RequestHandler.get(`${query}`).then((response) => {
      setFirmSelect({ data: response.value, loading: false });
      setVisibleUpdate(true);
    });
  };

  const handleCancel = (e) => {
    setVisibled(false);
  };

  const handleCancelUpdate = (e) => {
    setVisibleUpdate(false);
  };

  const handleCancelNoteUpdate = (e) => {
    setVisibleNoteUpdate(false);
  };

  const setDownloadExcel = () => {
    const hide = message.loading(t("pdfDownloading"), 0);
    window.open(
      `${
        config.apiUrl
      }/Pdf/DownloadPdfReceiptColumnsWithDoc?id=${accountIdForModalReceipt}&isDownload=true&t=${RequestHandler.getToken()}`
    );
    setIsModalVisible(true);
    alertSuccess("success");
    hide();
  };

  const showModalReceipt = (value) => {
    setAccountIdForModalReceipt(value);
    setEmailVisible(true);

    RequestHandler.get(
      `/Pdf/DownloadPdfReceiptColumnsWithDoc?id=${value}&isDownload=false`,
      undefined,
      { rawResponse: true }
    ).then((response) => {
      if (response.status == 200) {
        setPdfUrl(response.data);
        setIsModalVisible(true);
      }
    });
  };

  const handleOkReceipt = () => {
    setPdfUrl("");
    setIsModalVisible(false);
  };

  const handleOkTag = () => {
    RequestHandler.post(
      `/TenantTransactionTag`,
      {
        AccountTransactionId: accountTransactionId,
        tenantTransactionTags: tags,
      },
      true
    ).then((response) => {
      setIsModalTagVisible(false);
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    });
  };

  const handleCancelTag = () => {
    setIsModalTagVisible(false);
  };

  const handleCancelReceipt = () => {
    setPdfUrl("");
    setIsModalVisible(false);
  };

  const getTenantParameter = () => {
    RequestHandler.get("/TenantParameter/GetByTenant").then((response) => {
      if (response) {

        
        if(!response.isHasDateFilter && !response.isLast1DayFilterEnabled && !response.isLast7DaysFilterEnabled) {
           isInitialMount.current = false;
           getTableData();
        }

        setShowExchangePriceAndRate(response.isShowTransactionExchangePrice);
        setTransactionTimeFilter(response.isTransactionTimeFilter);
        setIsHasDateFilter(response.isHasDateFilter);
        setIsLast1DayFilterEnabled(response.isLast1DayFilterEnabled);
        setIsLast7DaysFilterEnabled(response.isLast7DaysFilterEnabled);
      }
    });
  };

  const onFirmSearch = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ data: [], loading: true });

      RequestHandler.get(
        `/Firm?$select=id,firmBranchNumber,name&$filter=isActive eq true and ${odata.contains(
          "name",
          value
        )} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        setFirmSelect({ data: res.value, loading: false });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  const countTagError = (type) => {
    notification[type]({
      message: t("error"),
      description: t("tagLengthError"),
      duration: 4,
    });
  };

  const exportExcel = () => {
    const hide = message.loading(t("excelDownloading"), 0);

    RequestHandler.post(
      `/ConsolidateAccountTransaction/ExportExcel`,
      { Query: getFilterQuery(), GroupId: groupId },
      false,
      { rawResponse: true }
    ).then((response) => {
      if (response.data.success) {
        openNotificationWithIconExcel("success");
        window.open(
          `${
            config.apiUrl
          }/ConsolidateAccountTransaction/downloadexcel?fileName=${
            response.data.message
          }&t=${RequestHandler.getToken()}`
        );
      } else {
        setLoading(false);
        setLoadingForWords(false);
        notification.error({
          message: response.data.message,
          duration: 3,
        });
      }
      hide();
    });
  };

  const handleId = (accountId) => {
    RequestHandler.get(`/AccountTransaction/Getbyid/${accountId}`).then(
      (response) => {
        response.firmId === null ? setFirmId("") : setFirmId(response.firmId);
        setId(response.id);
        response.vkn === null ? setVkn("") : setVkn(response.vkn);
        response.tckn === null ? setTckn("") : setTckn(response.tckn);
        response.senderName === null
          ? setSenderName("")
          : setSenderName(response.senderName);
        setDescriptionForMatch(response.description);

        RequestHandler.get(`/Firm/IsHaveFirm/${response.firmId}`).then(
          (res) => {
            if (!res) {
              setFirmId("");
            }
          }
        );
      }
    );
    setAccountId(accountId);
  };

  const menu = (
    <Menu>
      <Menu.Item>
        <a target="_blank" rel="noopener noreferrer" onClick={showDrawer}>
          {t("newAccountRecord")}
        </a>
      </Menu.Item>
      <Menu.Item>
        <a target="_blank" rel="noopener noreferrer" onClick={showModal}>
          {t("matchExistingFirm")}
        </a>
      </Menu.Item>
    </Menu>
  );

  const menuUpdate = (
    <Menu>
      <Menu.Item>
        <a target="_blank" rel="noopener noreferrer" onClick={showModalUpdate}>
          {t("updateExistingFirm")}
        </a>
      </Menu.Item>
    </Menu>
  );

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: t("success"),
      description: t("matchingSuccess"),
      duration: 4,
    });
  };

  const changeWithAccountIban = (type) => {
    notification[type]({
      message: t("success"),
      description: t("matchingSuccessWithIban"),
      duration: 5,
    });
  };

  const firmAccountNotSaved = (type) => {
    notification[type]({
      message: t("success"),
      description: t("matchingSuccessNoAccountAdded"),
      duration: 4,
    });
  };

  const sendSuccessMail = (type) => {
    notification[type]({
      message: t("success"),
      description: t("mailSendSuccess"),
      duration: 2,
    });
  };

  const mailEmptyError = (type) => {
    notification[type]({
      message: t("error"),
      description: t("emailAddressNotEntered"),
      duration: 2,
    });
  };

  const mailNotFound = (type) => {
    notification[type]({
      message: t("error"),
      description: t("emailAddressNotRegistered"),
      duration: 2,
    });
  };

  const onChange = (value) => setFirmId(value);

  const alertSuccess = (type) => {
    notification[type]({
      message: t("success"),
      description: t("pdfDownloadSuccess"),
      duration: 2,
    });
  };

  const wordLengtError = (type) => {
    notification[type]({
      message: t("error"),
      description: t("wordLengthError"),
      duration: 4,
    });
  };

  const firmWordMatchOk = (type) => {
    notification[type]({
      message: t("success"),
      description: t("wordAddSuccess"),
      duration: 4,
    });
  };

  const onFinishUpdateReceipt = (values) => {};

  const onFinishFailedUpdateReceipt = (values) => {};

  const onChangeEmail = (values) => {
    setEmail(values.target.value);
  };

  const sendMail = () => {
    setLoading(true);
    if (Email.length > 0) {
      RequestHandler.post(
        `/AccountTransaction/ReceiptSendMail`,
        { Email: Email, Path: pdfUrl, ScreenOption: Screen.screen },
        false,
        { rawResponse: true }
      ).then((res) => {
        if (res.data === "NotFound") {
          mailNotFound("error");
          setLoading(false);
        } else if (res.status == 204 || res.status == 200) {
          setLoading(false);
          setIsModalVisible(false);
          sendSuccessMail("success");
        }
      });
    } else {
      mailEmptyError("error");
      setLoading(false);
    }
  };

  const showVknTcknModal = () => {
    setVknTcknModal(true);
  };

  const onFinishUpdateWords = () => {
    const words = [];
    wordList.map((item) => {
      words.push(item.word.trim());
    });
    let error = 0;
    words.map((item) => {
      let wordLength = item.length;
      if (wordLength < 5 && wordLength !== 0) {
        error += 1;
      }
    });

    if (error == 0) {
      RequestHandler.put(
        `/Firm/FirmMatchingWordPut`,
        {
          FirmId: firmIdForVknTckn,
          Words: words.filter((item) => item.name !== ""),
        },
        false,
        { rawResponse: true }
      )
        .then((res) => {
          if (res.status === 200) {
            firmWordMatchOk("success");
            setLoadingForWords(false);
            window.location.reload();
          } else {
            setLoading(false);
            setLoadingForWords(false);
          }
        })
        .catch(function (error) {
          setLoadingForWords(false);
          setLoading(false);
        });
    } else {
      wordLengtError("error");
      setLoadingForWords(false);
    }
  };

  const onOkTcknVkn = () => {
    RequestHandler.post(
      `/Firm/GetDiffrentVknTckn`,
      {
        AccountTransactionId: AccountId,
        Id: firmIdForVknTckn,
        IsUpdateValue: true,
        IsIbanUpdateValue: true,
      },
      false
    ).then((response) => {
      if (response.data.accountIban === "") {
        openNotificationWithIcon("success");
        showModalWords();
      } else if (response.data.accountIban !== null) {
        changeWithAccountIban("success");
        showModalWords();
      } else {
        firmAccountNotSaved("success");
        showModalWords();
      }
    });
  };

  const onCancelTcknVkn = () => {
    openNotificationWithIcon("success");
    setVknTcknModal(false);
    setLoading(false);
    showModalWords(true);
  };

  const transactionNoteData = (record) => {
    RequestHandler.get(`/AccountTransaction/Getbyid/${record.id}`).then(
      (response) => {
        setTransactionId(response.id);
        setDrawerNoteUpdate(response.userNote);
        setVisibleNoteUpdate(true);
      }
    );
  };
  const onFinishNoteModal = (values) => {
    const { newNote } = values;
    RequestHandler.post(`/AccountTransaction/AccountTransactionUpdate`, {
      Id: transactionId,
      userNote: newNote,
    }).then((res) => {
      setLoading(false);
      setVisibleNoteUpdate(false);
      getTableData();
    });
  };

  const noteModalDelete = (id) => {
    RequestHandler.post(`/AccountTransaction/AccountTransactionUpdate`, {
      Id: id,
      userNote: null,
    }).then((res) => {
      setLoading(false);
      setVisibleNoteUpdate(false);
      getTableData();
    });
  };

  const onFinishUpdateWithoutModal = (values) => {
    RequestHandler.put(
      `/Firm`,
      {
        AccountTransactionId: AccountId,
        Id: values.FirmId,
      },
      false,
      { rawResponse: true }
    )
      .then((res) => {
        if (res.status == 200) {
          updateMatchFirm("success");
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          setLoading(false);
          setLoadingForWords(false);
        }
      })
      .catch(function (error) {
        setLoading(false);
        setLoadingForWords(false);
      });
  };

  const onFinishUpdate = (values) => {
    RequestHandler.get(`/Firm/GetMathingWordWithFirmId/${values.FirmId}`).then(
      (response) => {
        response.map((item) => {
          let model = {
            word: item.word,
          };
          wordArray.push(model);
        });
        wordArray.length < 1
          ? setWordList([{ word: "" }])
          : setWordList(wordArray);
      }
    );
    setFirmIdForVknTckn(values.FirmId);

    RequestHandler.put(
      `${config.apiUrl}/Firm`,
      {
        AccountTransactionId: AccountId,
        Id: values.FirmId,
      },
      false,
      { rawResponse: true }
    ).then((response) => {
      if (response.status == 200) {
        RequestHandler.post(
          `/Firm/GetDiffrentVknTckn`,
          {
            AccountTransactionId: AccountId,
            Id: values.FirmId,
          },
          false
        )
          .then((res) => {
            if (res.data.oldVkn !== null || res.data.oldTckn !== null) {
              showVknTcknModal();
              if (res.data.oldVkn !== res.data.newVkn) {
                setOldVkn(res.data.oldVkn);
                setNewVkn(res.data.newVkn);
              } else {
                setOldVkn(undefined);
                setNewVkn(undefined);
              }
              if (res.data.oldTckn !== res.data.newTckn) {
                setOldTckn(res.data.oldTckn);
                setNewTckn(res.data.newTckn);
              } else {
                setOldTckn(undefined);
                setNewTckn(undefined);
              }
            } else {
              if (res.data.AccountIban !== null) {
                RequestHandler.post(
                  `/Firm/GetDiffrentVknTckn`,
                  {
                    AccountTransactionId: AccountId,
                    Id: values.FirmId,
                    IsIbanUpdateValue: true,
                  },
                  false
                ).then((respp) => {
                  if (respp.data.accountIban === "") {
                    openNotificationWithIcon("success");
                    showModalWords();
                  } else if (respp.data.accountIban !== null) {
                    changeWithAccountIban("success");
                    showModalWords();
                  } else {
                    firmAccountNotSaved("success");
                    showModalWords();
                  }
                });
              } else {
                openNotificationWithIcon("success");
                showModalWords();
              }
            }
          })
          .catch(function (error) {
            setLoading(false);
            setLoadingForWords(false);
          });
      }
    });
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...wordList];
    list[index][name] = value;
    setWordList(list);
  };

  const handleRemoveClick = (index) => {
    const list = [...wordList];
    list.splice(index, 1);
    setWordList(list);
  };

  const handleAddClick = () => {
    setWordList([...wordList, { word: "" }]);
  };

  const onFinishFailedUpdate = (errorInfo) => {};

  const onFinishFailedUpdateWords = () => {
    setVisibleWords(false);
  };

  const getColumns = () => {
    const beforeDynamicColumns = [
      {
        title: t("bank"),
        dataIndex: "bankId",
        key: "bankId",
        render: (text, row, index) => {
          return (
            <div style={{ width: 84 }}>
              <img src={row.tenantBankLogo}></img>
            </div>
          );
        },
      },
      {
        title: t("company"),
        dataIndex: "tenantName",
        key: "tenantName",
        width: "11%",
      },
      tableRoles.isAccountNameShow
        ? {
            title: t("accountName"),
            dataIndex: "tenantAccountName",
            key: "tenantAccountName",
          }
        : {},
      tableRoles.isTenantIbanShow === true
        ? {
            title: t("ibanOrAccountNumber"),
            align: "center",
            dataIndex: "ibanOrAccountNumber",
            key: "ibanOrAccountNumber",
          }
        : {},
      tableRoles.isIbanShow === true && tableRoles.isIbanShowInColumn === true
        ? {
            title: t("counterIbanOrAccountNumber"),
            align: "center",
            dataIndex: "iban",
            key: "iban",
            render: (text) => (text ? text : null),
          }
        : {},
      tableRoles.isSenderNameShow === true &&
      tableRoles.isSenderNameShowColumn === true
        ? {
            title: t("senderName"),
            dataIndex: "senderName",
          }
        : { title: "" },
      {
        title: t("amount"),
        dataIndex: "amountString",
        key: "amountString",
        align: "center",
        sorter: true,
        render: (text, row, index) => {
          {
            return Screen.screenGercek === 2 || tableRoles.isAmountColorful ? (
              <div
                style={{ width: 98, whiteSpace: "nowrap", textAlign: "right" }}
              >
                {text.includes("-") ? (
                  <div style={{ color: "red" }}>{text}</div>
                ) : (
                  <div style={{ color: "green", whiteSpace: "nowrap" }}>
                    {text}
                  </div>
                )}
              </div>
            ) : (
              <div
                style={{ width: 98, whiteSpace: "nowrap", textAlign: "right" }}
              >
                {text}
              </div>
            );
          }
        },
      },
    ];

    if (showExchangePriceAndRate) {
      beforeDynamicColumns.push({
        title: t("exchangeRateAndPrice"),
        dataIndex: "exchangeRateAndPriceString",
        align: "center",
        width: "10%",
      });
    }

    if (isHaveAccountRole.data && tableRoles.isBalanceAfterTransactionShow) {
      beforeDynamicColumns.push({
        title: t("balanceAfterTransaction"),
        align: "center",
        render: (row) => (
          <div style={{ textAlign: "right" }}>
            {ColumnHelper.renderDecimal(row.balanceAfterTransaction)}
          </div>
        ),
      });
    }

    return beforeDynamicColumns.concat([
      tableRoles.isCurrencyShow === true
        ? {
            title: t("currency"),
            dataIndex: "currency",
            align: "center",
            key: "currency",
            render: (text, row, index) => {
              {
                return <div>{text}</div>;
              }
            },
          }
        : {},
      {
        title: t("date"),
        dataIndex: "transactionDate",
        align: "center",
        width: "11%",
        key: "transactionDateValue",
        sorter: (a, b) =>
          moment(a.transactionDateValue).unix() -
          moment(b.transactionDateValue).unix(),
        render: (text, row, index) => {
          {
            return <div> {row.transactionDate} </div>;
          }
        },
      },
      tableRoles.isDescriptionShow === true
        ? {
            title: t("description"),
            align: "left",
            dataIndex: "description",
            width: "34%",
            key: "description",
            render: (text, row, index) => (
              <Tooltip placement="topLeft" title={text}>
                <div style={{ whiteSpace: "break-spaces" }}>
                  {text?.substring(0, 60) === undefined
                    ? " "
                    : text?.trim().length <= 60
                    ? text + ""
                    : text?.substring(0, 125) + "..."}
                </div>
              </Tooltip>
            ),
          }
        : {},
      isFirmHidden
        ? tableRoles.isFirmNameShow === true
          ? {
              title: t("firmName"),
              dataIndex: "firmName",
              align: "center",
              key: "firmName",
              render: (text, row, index) =>
                text == null ? (
                  <div style={{ opacity: 0.7 }}>-</div>
                ) : (
                  <Tooltip placement="topLeft" title={text}>
                    {text?.substring(0, 15) === undefined ? (
                      <div style={{ opacity: 0.7 }}>-</div>
                    ) : text?.substring(0, 15).length < 8 ? (
                      text?.substring(0, 15) + ""
                    ) : (
                      text?.substring(0, 8) + "..."
                    )}
                  </Tooltip>
                ),
            }
          : {}
        : {},
      {
        title: t("receipt"),
        dataIndex: "id",
        width: "1%",
        align: "center",
        render: (data) => {
          return (
            <a
              style={{ color: "black", fontSize: "130%" }}
              onClick={() => showModalReceipt(data)}
            >
              {" "}
              <FilePdfOutlined />
            </a>
          );
        },
      },
    ]);
  };

  const columns = getColumns();

  const detailColumns = [
    tableRoles.isIbanShow === true && tableRoles.isIbanShowInColumn === false
      ? {
          title: t("counterIban"),
          dataIndex: "iban",
        }
      : { title: "" },
    tableRoles.isVknTcknShow === true
      ? {
          title: t("vknOrTckn"),
          dataIndex: "vkn",
          render: (data, row, index) => data ?? row.tckn,
        }
      : { title: "" },
    tableRoles.isTransactionTypeShow === true
      ? {
          title: t("transactionType"),
          dataIndex: "transactionTypeName",
        }
      : { title: "" },
    tableRoles.isSenderNameShow === true &&
    tableRoles.isSenderNameShowColumn === false
      ? {
          title: t("senderName"),
          dataIndex: "senderName",
        }
      : { title: "" },
    tableRoles.isReceiptShow === true
      ? {
          title: t("receiptNumber"),
          dataIndex: "receiptNumber",
        }
      : { title: "" },
    tableRoles.isDescriptionShow === true
      ? {
          title: t("bankDescription"),
          dataIndex: "description",
        }
      : { title: "" },
    tableRoles.isAdditionalDescriptionShow === true
      ? {
          title: t("additionalDescription"),
          dataIndex: "additionalDescription",
        }
      : { title: "" },
    tableRoles.isNoteShow === true
      ? {
          title: t("note"),
          dataIndex: "userNote",
        }
      : { title: "" },
  ];

  return (
    <>
      {queryHelper.getFilterFromQuery() && (
        <Row style={{ marginBottom: 9 }}>
          <Col flex={1}>
            <a
              onClick={() => history.goBack()}
              style={{ color: "black", marginLeft: "4%" }}
            >
              {" "}
              <RollbackOutlined /> {t("goBack")}
            </a>
          </Col>
          <Col flex={4}></Col>
        </Row>
      )}

      <Row>
        <Col xs={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> {t("consolidatedAccountTransactions")}
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
          <Select
            showSearch
            style={{ width: 200, textAlign: "left", marginRight: 5 }}
            placeholder={t("allMini")}
            optionFilterProp="children"
            onChange={onGroupChange}
            value={firstGroup}
            filterOption={(input, option) =>
              option.props.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
          >
            {groups.map((item) => (
              <Option key={item.id}>{item.name}</Option>
            ))}
          </Select>

          <Tooltip title={t("downloadExcel")}>
            <a
              style={{
                color: "green",
                fontSize: "180%",
                marginRight: 30,
              }}
              onClick={exportExcel}
            >
              <FileExcelOutlined />
            </a>
          </Tooltip>
        </Col>
      </Row>

      <ConsolidateAccountTransactionTableFilter
        isTransactionTimeFilter={isTransactionTimeFilter}
        groupId={groupId}
        data={tableDataQueryOptions.values}
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
        extraText={isHasDateFilter ? "Varsayılan olarak son 1 aylık veri listelenmektedir." : isLast1DayFilterEnabled ? "Varsayılan olarak son 1 günlük veri listelenmektedir.": isLast7DaysFilterEnabled ? "Varsayılan olarak son 7 günlük veri listelenmektedir." : ""}
      />

      <Tabs
        defaultActiveKey={tableDataQueryOptions.activeTab}
        onChange={onTabChange}
      >
        {currencyTabList.length !== 0 && (
          <>
            <Tabs.TabPane tab={t("all")} key="0" />
            {currencyTabList.map((item) => (
              <Tabs.TabPane tab={item.currency} key={item.currencyId} />
            ))}
          </>
        )}
      </Tabs>

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            expandable={{
              expandedRowRender: (row) =>
                RowHelper.renderRowDetail({
                  data: row,
                  columns: detailColumns,
                }),
            }}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={t("noData")}
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>

      <Drawer
        title={t("addFirm")}
        width={241}
        onClose={onClose}
        visible={addFirmDrawerVisible}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          ></div>
        }
      >
        <FirmAddForm
          AccountId={AccountId}
          SenderName={senderName}
          Tckn={Tckn}
          Vkn={Vkn}
          Id={Id}
        />
      </Drawer>

      <Modal
        title={t("matchExistingFirm")}
        visible={visibled}
        onCancel={handleCancel}
        closable={true}
        footer={[]}
        width={600}
      >
        <Row justify="end">
          <Form
            {...layout}
            name="basic"
            style={{ width: "100%" }}
            initialValues={{
              remember: true,
            }}
            onFinish={onFinishUpdate}
            onFinishFailed={onFinishFailedUpdate}
          >
            <Col>
              <Form.Item
                label={t("firmNameTitle")}
                name="FirmId"
                style={{ marginRight: 60 }}
                rules={[
                  {
                    required: true,
                    message: t("firmNameRequired"),
                  },
                ]}
              >
                <Select
                  style={{ width: 375 }}
                  showSearch
                  optionFilterProp="children"
                  onChange={onChange}
                  placeholder={t("enterAtLeast2Letters")}
                  onSearch={onFirmSearch}
                  filterOption={(input, option) =>
                    option.children
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                    option.code
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                  }
                  loading={firmSelect.loading}
                >
                  {firmSelect.data.map((item) => (
                    <Select.Option
                      key={item.id}
                      value={item.id}
                      code={item.firmBranchNumber}
                      title={item.name}
                    >
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col
              span={24}
              style={{
                textAlign: "right",
              }}
            >
              <Form.Item {...tailLayouttwo}>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  htmlType="submit"
                  onClick={() => setLoading(true)}
                  loading={loading}
                >
                  {t("match")}
                </Button>
              </Form.Item>
            </Col>
          </Form>
        </Row>
      </Modal>

      <Modal
        title={t("editNote")}
        visible={visibleNoteUpdate}
        onCancel={handleCancelNoteUpdate}
        closable={true}
        footer={null}
        destroyOnClose={false}
      >
        <div style={{ marginBottom: "-40px" }}>
          <Row justify="end">
            <Form
              name="basic"
              style={{ width: "100%" }}
              onFinish={onFinishNoteModal}
              onFinishFailed={onFinishFailedUpdate}
              fields={[{ name: "newNote", value: drawerNoteUpdate }]}
            >
              <Form.Item name="newNote">
                <Input.TextArea
                  placeholder={t("writeYourNoteHere")}
                  autoSize={{ minRows: 6, maxRows: 6 }}
                  value={drawerNoteUpdate}
                  onChange={(e) => setDrawerNoteUpdate(e.target.value)}
                />
              </Form.Item>
              <Col
                span={24}
                style={{
                  textAlign: "right",
                }}
              >
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    onClick={() => setLoading(true)}
                    loading={loading}
                  >
                    {t("edit")}
                  </Button>
                </Form.Item>
              </Col>
            </Form>
          </Row>
        </div>
      </Modal>

      <Modal
        title={t("updateExistingFirm")}
        visible={visibleUpdate}
        onCancel={handleCancelUpdate}
        closable={true}
        footer={[]}
        width={600}
      >
        <Row justify="end">
          <Form
            {...layout}
            name="basic"
            style={{ width: "100%" }}
            initialValues={{
              remember: true,
            }}
            onFinish={onFinishUpdateWithoutModal}
            onFinishFailed={onFinishFailedUpdate}
            fields={[{ name: "FirmId", value: firmId }]}
          >
            <Col>
              <Form.Item
                label={t("firmNameTitle")}
                name="FirmId"
                style={{ marginRight: 60 }}
                rules={[
                  {
                    required: true,
                    message: t("firmNameRequired"),
                  },
                ]}
              >
                <Select
                  style={{ width: 375 }}
                  showSearch
                  optionFilterProp="children"
                  onChange={onChange}
                  placeholder={t("enterAtLeast2Letters")}
                  onSearch={onFirmSearch}
                  filterOption={(input, option) =>
                    option.children
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                    option.code
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                  }
                  loading={firmSelect.loading}
                >
                  {firmSelect.data.map((item) => (
                    <Select.Option
                      key={item.id}
                      value={item.id}
                      code={item.firmBranchNumber}
                      title={item.name}
                    >
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col
              span={24}
              style={{
                textAlign: "right",
              }}
            >
              <Form.Item {...tailLayouttwo}>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  htmlType="submit"
                  onClick={() => setLoading(true)}
                  loading={loading}
                >
                  {t("update")}
                </Button>
              </Form.Item>
            </Col>
          </Form>
        </Row>
      </Modal>

      <Modal
        title={t("wordMatching")}
        visible={visibledWords}
        onCancel={handleCancelWords}
        closable={true}
        footer={[]}
      >
        <p>{t("wordMatchingQuestion")}</p>
        <p style={{ marginBottom: 20 }}>
          {t("description")}:
          <p>
            <strong>{descriptionForMatch}</strong>
          </p>
        </p>
        <p></p>
        <p>{t("existingWordsInfo")}</p>
        <p></p>
        <Row justify="end">
          <Form
            {...layout}
            name="basic"
            initialValues={{
              remember: true,
            }}
            onFinish={onFinishUpdateWords}
            onFinishFailed={onFinishFailedUpdateWords}
          >
            <Form.Item label={t("words")} name="words">
              {wordList.map((x, i) => {
                return (
                  <Row>
                    <Col span={20} style={{ marginLeft: "-6%" }}>
                      <Input
                        name="word"
                        placeholder={t("enterWord")}
                        value={x.word}
                        onChange={(e) => handleInputChange(e, i)}
                      />
                    </Col>
                    <Col span={2}>
                      {wordList.length !== 1 && (
                        <Button
                          className="mr10"
                          onClick={() => handleRemoveClick(i)}
                        >
                          <MinusOutlined />
                        </Button>
                      )}
                      {wordList.length - 1 === i && (
                        <Button onClick={handleAddClick}>
                          <PlusOutlined />
                        </Button>
                      )}
                    </Col>
                    <Col></Col>
                  </Row>
                );
              })}
            </Form.Item>
            <Form.Item {...tailLayout}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoadingForWords(true)}
                loading={loadingForWords}
              >
                {t("update")}
              </Button>
            </Form.Item>
          </Form>
        </Row>
      </Modal>

      <Modal
        title={t("tag")}
        width={600}
        style={{ height: 1000 }}
        visible={isModalTagVisible}
        onOk={handleOkTag}
        onCancel={handleCancelTag}
        okText="Kaydet"
      >
        <Spin spinning={spinLoading} tip={t("loading")}>
          <ReactTags
            tags={tags}
            suggestions={suggestions}
            placeholder={t("enterTag")}
            onAddHandler={(val) => addTag(val)}
            onDeleteHandler={(idx) => removeTag(idx)}
            onChangeHandler={(val) => handleTagChange(val)}
          />
        </Spin>
      </Modal>

      {isDesktopOrLaptop ? (
        <Modal
          title={t("receipt")}
          width={1000}
          style={{ height: 1000 }}
          visible={isModalVisibleReceipt}
          onOk={handleOkReceipt}
          onCancel={handleCancelReceipt}
          footer={null}
        >
          <Form
            {...layout}
            name="basic"
            initialValues={{
              remember: true,
            }}
            onFinish={onFinishUpdateReceipt}
            onFinishFailed={onFinishFailedUpdateReceipt}
            fields={[{ name: "Email", value: Email }]}
          >
            <Row>
              <Col span={20}></Col>
              <Col span={2}>
                {EmailVisible ? (
                  <MailOutlined
                    style={{ fontSize: 20, marginBottom: 20 }}
                    onClick={() => setEmailVisible(!EmailVisible)}
                  />
                ) : (
                  <MailFilled
                    style={{ fontSize: 20, marginBottom: 20 }}
                    onClick={() => setEmailVisible(!EmailVisible)}
                  />
                )}
              </Col>
              <Col span={2}>
                <DownloadOutlined
                  style={{ fontSize: 20, marginBottom: 20 }}
                  onClick={() => setDownloadExcel()}
                />
              </Col>
            </Row>
            <Row hidden={EmailVisible}>
              <Col span={18}>
                <Form.Item
                  label={t("emailAddress")}
                  name="Email"
                  style={{ width: "100%" }}
                >
                  <Input value={Email} onChange={onChangeEmail} />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item>
                  <Button
                    type="primary"
                    onClick={() => sendMail()}
                    loading={loading}
                  >
                    {t("send")}
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Iframe
            url={pdfUrl}
            width="100%"
            height="1000px"
            id="myId"
            className="myClassname"
            display="initial"
            position="relative"
          />
        </Modal>
      ) : (
        <Modal
          title={t("receipt")}
          visible={isModalVisibleReceipt}
          onOk={handleOkReceipt}
          onCancel={handleCancelReceipt}
          footer={null}
        >
          <Form
            {...layout}
            name="basic"
            initialValues={{
              remember: true,
            }}
            onFinish={onFinishUpdateReceipt}
            onFinishFailed={onFinishFailedUpdateReceipt}
            fields={[{ name: "Email", value: Email }]}
          >
            <Row>
              <Col span={14}></Col>
              <Col span={5}>
                {EmailVisible ? (
                  <MailOutlined
                    style={{ fontSize: 20, marginBottom: 20 }}
                    onClick={() => setEmailVisible(!EmailVisible)}
                  />
                ) : (
                  <MailFilled
                    style={{ fontSize: 20, marginBottom: 20 }}
                    onClick={() => setEmailVisible(!EmailVisible)}
                  />
                )}
              </Col>
              <Col span={5}>
                <DownloadOutlined
                  style={{ fontSize: 20, marginBottom: 20 }}
                  onClick={() => setDownloadExcel()}
                />
              </Col>
            </Row>
            <Row hidden={EmailVisible}>
              <Col span={12}>
                <Form.Item label="" name="Email" style={{ width: "140%" }}>
                  <Input value={Email} onChange={onChangeEmail} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item>
                  <Button
                    type="primary"
                    onClick={() => sendMail()}
                    loading={loading}
                  >
                    {t("send")}
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Iframe
            url={pdfUrl}
            width="100%"
            height="400px"
            id="myId"
            className="myClassname"
            display="initial"
            position="relative"
          />
        </Modal>
      )}

      <Modal
        title=""
        visible={vknTcknModal}
        onOk={onOkTcknVkn}
        onCancel={onCancelTcknVkn}
        okText={t("update")}
        cancelText={t("cancel")}
      >
        <p>
          {t("tcknVknMismatchMessage", {
            tckn: newTckn === undefined ? "" : t("tcknLabel", " Tckn"),
            vkn: newVkn === undefined ? "" : t("vknLabel", " Vkn"),
          })}
        </p>

        {oldTckn !== undefined && (
          <p>{t("accountTransactionTckn", { value: oldTckn })}</p>
        )}
        {oldTckn !== undefined && (
          <p>
            {t("firmTcknWithValue", {
              value: newTckn === null ? t("emptyValue") : newTckn,
            })}
          </p>
        )}
        {oldVkn !== undefined && (
          <p>{t("accountTransactionVkn", { value: oldVkn })}</p>
        )}
        {oldVkn !== undefined && (
          <p>
            {t("firmVknWithValue", {
              value: newVkn === null ? t("emptyValue") : newVkn,
            })}
          </p>
        )}

        <p>{t("updateFieldsConfirmation")}</p>
      </Modal>
    </>
  );
};

export default ConsolidatedAccountPage;
